import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { routesPath } from '@router/routes';

import { useAuditTrialsFiltersSlice } from '@restore/auditTrailsFilters/auditFilters.slice';
import { useAuthSlice } from '@restore/auth/auth.slice';
import { useClinicalTrialContextSlice } from '@restore/clinicalTrialContext/clinicalTrialContext.slice';
import { useClinicalTrialAffiliatesSlice } from '@restore/clinicalTrialAffiliates/clinicalTrialAffiliates.slice';
import { ClinicalTrialAffiliatesType } from '@dynamika-shared/types/clinicalTrialAffiliates';
import { ClinicalTrialList } from '@components/LoginSelections/ClinicalTrialList/ClinicalTrialList';

export const SponsorsMenu = () => {
  const userData = useAuthSlice(s => s.data);
  const { id: clinicalTrialId } = useParams<{
    id: string;
  }>();

  const [dataCT, fetchClinicalTrials] = useClinicalTrialAffiliatesSlice(
    (state, actions) => [state.data, actions.fetchClinicalTrialAffiliates]
  );

  const [fetchContext, clearData, contextData] = useClinicalTrialContextSlice(
    (state, actions) => [
      actions.fetchClinicalTrialContext,
      actions.clearData,
      state.data,
    ]
  );

  const clearAuditListStore = useAuditTrialsFiltersSlice(
    (state, actions) => actions.clear
  );

  useEffect(() => {
    if (!dataCT?.length) {
      fetchClinicalTrials(null);
    }
  }, [dataCT]);

  useEffect(() => {
    if (clinicalTrialId && clinicalTrialId !== contextData?.configuration?.id) {
      const setNewContext = async (ctId: string) => {
        clearAuditListStore();
        clearData();
        fetchContext(ctId);
      };
      setNewContext(clinicalTrialId);
    }
  }, [clinicalTrialId]);

  const navigate = useNavigate();

  const handleSelectCT = (clinicalTrial: ClinicalTrialAffiliatesType) => {
    navigate(`${routesPath.sponsor}/${clinicalTrial.id}`);
  };

  if (!userData?.selectedRole) {
    return null;
  }
  return (
    <ClinicalTrialList
      clinicalTrials={dataCT}
      handleSelectCT={handleSelectCT}
      context={'menu'}
    />
  );
};
